export default {
    billing: {
        que: "Facturación de AWS: consulta y paga tus facturas, define cómo pagas y administra créditos. Cobra por uso, a fin de mes.",
        patron: "lineal",
        nodos: [["Uso de servicios", "servidor"], ["Facturación", "archivo"], ["Pago", "clave"]],
        pasos: ["Cada servicio mide lo que usas (horas, GB, peticiones).", "A fin de mes se suma por servicio, se descuentan créditos y se genera la factura, que se cobra al método de pago registrado."],
        objetos: {
            "Facturas": ["Detalle mensual por servicio y cuenta, descargable.", 1],
            "Métodos de pago": ["Tarjeta o cuenta con la que se cobra.", 2],
            "Créditos": ["Saldos promocionales o de programas que se descuentan de la factura.", 1],
        },
    },
    costexplorer: {
        que: "Gráficos y filtros para entender en qué se gasta y proyectar lo que viene, por servicio, cuenta, etiqueta o región.",
        patron: "lineal",
        nodos: [["Costos y uso", "datos"], ["Cost Explorer", "grafico"], ["Recomendaciones", "lupa"]],
        pasos: ["Cost Explorer toma tus datos de costo de los últimos meses.", "Los agrupa por la dimensión que elijas, proyecta el gasto y sugiere dónde ahorrar: reservas, Savings Plans, recursos sobredimensionados."],
        objetos: {
            "Costos": ["Gasto diario o mensual filtrado por servicio, cuenta o etiqueta.", 0],
            "Reservas": ["Cobertura y uso de instancias reservadas.", 1],
            "Savings Plans": ["Compromiso de gasto por hora a cambio de un descuento.", 1],
            "Recomendaciones": ["Sugerencias de tamaño correcto y de compromisos.", 2],
        },
    },
    budgets: {
        que: "Presupuestos con alertas: defines cuánto quieres gastar y AWS te avisa (o actúa) cuando el gasto real o el proyectado se acerca al límite.",
        patron: "lineal",
        nodos: [["Gasto real", "datos"], ["Presupuesto", "reloj"], ["Alerta", "campana"], ["Acción", "funcion"]],
        pasos: ["Budgets compara el gasto con el monto del presupuesto.", "Al llegar a los umbrales (80 %, 100 %, proyectado) se envía una alerta.", "Opcionalmente ejecuta una acción, como aplicar una política que restrinja lanzar nuevos recursos."],
        objetos: {
            "Presupuestos": ["Meta de costo, uso o cobertura para un periodo.", 1],
            "Acciones": ["Respuestas automáticas al superar un umbral.", 3],
            "Alertas": ["Avisos por correo o SNS al cruzar un porcentaje.", 2],
        },
    },
    cur: {
        que: "El informe de costos y uso más detallado: un archivo con cada línea de uso y su costo, entregado a S3 para analizarlo con Athena o QuickSight.",
        patron: "lineal",
        nodos: [["Uso por hora", "reloj"], ["Cost & Usage Report", "archivo"], ["S3 + Athena", "grafico"]],
        pasos: ["AWS registra cada recurso y cada hora de uso con su costo.", "Entrega el informe a un bucket de S3 (CSV o Parquet), listo para consultarlo con SQL."],
        objetos: { "Informes": ["Configuración del informe: nivel de detalle, formato y bucket de entrega.", 1] },
    },
};
